export const filterIntegerInput = (value) => value.replace(/[^0-9]/, '');

export const isNumeric = (value) => {
  const regExp = /^\d*(\.\d*)?$/;
  return regExp.test(value);
};

export const filterFloatValue = (value) => value.replace(/[^0-9.]/, '');

export default {
  filterIntegerInput,
  filterFloatValue,
  isNumeric
};
